import React from 'react';
import PropTypes from 'prop-types';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';

import PureRenderMixin from 'react-addons-pure-render-mixin';
import urlMapping from '../app/URLMapping';
import {sendError} from '../app/errorDisplayer';
import {injectIntl, defineMessages, } from 'react-intl';
import config from '../../common/config';
import {lastPanelController} from './EmbededPanelController';
import ResizeSensor from 'css-element-queries/src/ResizeSensor';
import MiniLogo from '../app/MiniLogo.react';
import {isOutlookPanel, isScreenSettingsOnlyIframe, screenSettingsOnlyClose} from '../../outlook/dialog';
import {LoadingLine} from '../loadingLine/renderLoadingPanel.react';
import {isPanelInjected} from '../loadingLine/renderLoadingPanel.react';

const messages = defineMessages({
    backToPanel: {id: 'panel.backToPanel', 'defaultMessage': 'Restore back'},
    close: {id: 'panel.close', 'defaultMessage': 'Close panel'},
    restore: {id: 'panel.restore', 'defaultMessage': 'Restore back'},
	minimalize: {id: 'panel.minimalize', 'defaultMessage': 'Minimalize panel'},
	maximalize: {id: 'panel.maximalize', 'defaultMessage': 'Maximalize panel'},
    menu: {id: 'panel.menu', 'defaultMessage': 'Menu'},
    reloading: {id: 'panel.reloading', 'defaultMessage': 'Reloading'},
    config: {id: 'panel.config', 'defaultMessage': 'Configure panel'}
});

class BasicPanel extends React.Component {

    static propTypes = {
        children: PropTypes.node,
        className: PropTypes.string,
        close: PropTypes.func,
        config: PropTypes.func,
        fullscreen: PropTypes.func,
        hideClose: PropTypes.bool,
        hideMenu: PropTypes.bool,
		hideMinimalize: PropTypes.bool,
        intl: PropTypes.object.isRequired,
        isReloading: PropTypes.bool,
        restore: PropTypes.func,
        typeForTest: PropTypes.string.isRequired,
    };

    static contextTypes = {
        router: PropTypes.object,
    };

    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);

        this.state = {
            configOpening: false
        };

		this.mounted = false;
    }

    menu = () => {
        /* sometime when object are destroyed, context is destroyed too */
        if (lastPanelController()) {
            let urlObject = lastPanelController().getURLObject();
            let path = urlMapping.getUrl("panel", "menu", urlObject);
            this.context.router.push(path);
        }
    };

    close = () => {
        if (this.props.close) {
            this.props.close();
        } else {
            let urlObject = lastPanelController().getURLObject();

            lastPanelController().minimizePanel();
            if (urlObject['organisation_id']) {
                let path = urlMapping.getUrl("panel", "mini", urlObject);
                this.context.router.push(path);
            } else {
                let path = urlMapping.getUrl("panel", "empty", urlObject);
                this.context.router.push(path);
            }
        }
    };

    backToPanel = () => {
		if (isOutlookPanel()) {
			window.close();
		}
        else if (this.props.close) {
            this.props.close();
        }
		else if (isScreenSettingsOnlyIframe()) {
			screenSettingsOnlyClose();
		}
		else {
            lastPanelController().cancelMinimizePanel();

            let urlObject = lastPanelController().getURLObject();

            if (urlObject['screen_id']) {
                let path = urlMapping.getUrl("panel", "panel", lastPanelController().getURLObject());
                this.context.router.push(path);
            } else if (lastPanelController().state.haveScreenData) {
                let path = urlMapping.getUrl("panel", "no-screen", lastPanelController().getURLObject());
                this.context.router.push(path);
            } else {
                let path = urlMapping.getUrl("panel", "empty", lastPanelController().getURLObject());
                this.context.router.push(path);
            }
        }
    };

    getClassName() {
        throw new Error("Not implemented");
    }

    isFullScreen() {
        return false;
    }

    isMini() {
        return false;
    }

    resizer(resizerID, mousemove, cursor) {
        let resizer = document.getElementById(resizerID);
        resizer.mousemove = mousemove;

        resizer.onmousedown = (e) => {
            try {
                this.isResizing = true;
                document.documentElement.addEventListener('mousemove', resizer.doDrag, false);
                document.documentElement.addEventListener('mouseup', resizer.stopDrag, false);
            } catch (e) {
                sendError(e, "resizer.onmousedown(...) failed! Your browser does not support this feature. " + e.message);
            }
        };

        resizer.doDrag = (e) => {
            if (e.which !== 1) {
                resizer.stopDrag(e);
                return;
            }
            //consoleLog("doDrag(e)");
            resizer.mousemove(e);
        };

        resizer.stopDrag = (e) => {
            this.isResizing = false;
            document.documentElement.removeEventListener('mousemove', resizer.doDrag, false);
            document.documentElement.removeEventListener('mouseup', resizer.stopDrag, false);
        };
    }

    resizerX(resizerID, mousemove) {
        this.resizer(resizerID, mousemove, "col-resize");
    }

    resizerY(resizerID, mousemove) {
        this.resizer(resizerID, mousemove, "row-resize");
    }

    resizerXY(resizerID, mousemove) {
        this.resizer(resizerID, mousemove, "all-resize");
    }

    computeHeight() {
        //wait for a paint to do scrolly stuff
        window.requestAnimationFrame(() => {

            if (!lastPanelController()) {
                return;
            }

			let panelState = lastPanelController().state;

            if (this.refs.embedContentClient && !this.isFullScreen() && !this.isMini() && panelState.orientation === "horizontal") {
                let c = this.refs.embedContentClient;
                if (c.childNodes && c.childNodes.length > 0) {
                    c = c.childNodes[0];
                }

				let sizes = c.getBoundingClientRect();

                let height = sizes.height + sizes.top;
                if (height < 70) {
                    height = 70;
                }

                if (panelState.isInjected === false) {
					if ((!panelState.initialized || panelState.haveScreenData) && height < 98) {
						height = 98;
					}
					else if (height < 78) {
                        height = 78;
                    }
                }

                /* resize only when actual page size has changed +- pixel for rounding differences */
				let documentHeight = document.documentElement.clientHeight;
				if (documentHeight - 1 > height || height > documentHeight + 1) {
                    lastPanelController().resizeY(height);
                }
            }
        });
    }

    componentDidMount() {
		// ISSUE #319
        // if (lastPanelController() && lastPanelController().state.isInjected === false) {
		//
		//
        //     this.resizerY("embedDativeryResizeLine", (e) => {
        //         let height = document.getElementById('embedDativeryPanel').clientHeight - e.pageY;
		//
        //         if (height < 130) {
        //             height = 130;
        //         }
		//
        //         lastPanelController().resizeY(height);
        //     });
        // }

        let child = this.refs.embedContentClient.childNodes[0];
        if (!child) {
            child = this.refs.embedContentClient;
        }

        new ResizeSensor(child, () => {
            /* ignore resize when dragging and resizing */
            if (!this.isResizing) {

                /* delay update to skip too frequent updates */
                if (!this.resizeTimeout) {
                    this.resizeTimeout = setTimeout(() => {
                        this.resizeTimeout = null;
                        this.computeHeight();
                    }, 300);
                }
            }
        });

		setTimeout(() => {
			this.computeHeight();
		}, 100);

		this.mounted = true;
    }

	componentWillUnmount() {
		this.mounted = false;
	}

    config = () => {
        this.setState({
            configOpening: true
        });

        setTimeout(() => {
			if (this.mounted) {
				this.setState({
					configOpening: false
				});
			}
        }, 2000);

        this.props.config();
    };

    renderSidePanel(isInjected, isHorizontal) {
		const closeTooltip = (
			<Tooltip className="panelTooltip" id="backToPanelTooltip">{this.props.intl.formatMessage(messages.backToPanel)}</Tooltip>
		);

		const maximalizeTooltip = (
			<Tooltip className="panelTooltip" id="maximalizeTooltip">{this.props.intl.formatMessage(messages.maximalize)}</Tooltip>
		);

		const minimalizeTooltip = (
			<Tooltip className="panelTooltip" id="minimalizeTooltip">{this.props.intl.formatMessage(messages.minimalize)}</Tooltip>
		);

		const configureTooltip = (
			<Tooltip className="panelTooltip" id="configTooltip">{this.props.intl.formatMessage(messages.config)}</Tooltip>
		);

		const dativeryTooltip = (
			<Tooltip className="panelTooltip" id="dativeryTooltip">{config.PRODUCT_NAME}</Tooltip>
		);

		let hasOwnTooltip = false;
		if (lastPanelController()) {
			hasOwnTooltip = lastPanelController().tooltip;
		}

        return (<div>
            {!this.isMini() ?
                (this.isFullScreen() && !this.props.hideClose
                        ?
						<OverlayTrigger delayShow={400} overlay={closeTooltip} placement="right">
							<div className="embedSidePanelIcon closeScreenSettings" onClick={this.backToPanel}>
								<i aria-hidden="true" className="fa fa-fw fa-times" ></i>
							</div>
						</OverlayTrigger>
                        :
                        ((!isInjected && !this.props.hideMinimalize) ?
							<OverlayTrigger delayShow={400} overlay={minimalizeTooltip} placement="right">
								<div className="embedSidePanelIconHide minimalizePanel" onClick={this.close}>
									<i aria-hidden="true" className="fa fa-fw  fa-angle-double-left" ></i>
								</div>
							</OverlayTrigger>
						: null)
                ) : null}
            {this.props.restore
				? <OverlayTrigger delayShow={400} overlay={maximalizeTooltip} placement="right">
					<div className="embedSidePanelIconShow maximalizePanel" onClick={this.props.restore}><i aria-hidden="true" className="fa fa-fw fa-angle-double-right" ></i></div>
				</OverlayTrigger>
				: null}
            {/*!this.props.hideMenu ? <div className="embedSidePanelIcon" onClick={this.menu}  title={this.props.intl.formatMessage(messages.menu)}><i aria-hidden="true" className="fa fa-fw fa-bars" ></i></div> : null*/}

            <div className="embedSidePanelBottom">
                {lastPanelController() && lastPanelController().state.isReloading || this.props.isReloading ?
                    <div className="embedSidePanelIcon loading" title={this.props.intl.formatMessage(messages.reloading)}><i aria-hidden="true" className="fa fa-refresh fa-spin fa-fw" ></i></div>
                    :
                    (this.props.config ?
						(hasOwnTooltip ?
							<div className="embedSidePanelIcon openScreenSettings" onClick={this.config}>
								<i className={"fa fa-fw " + (this.state.configOpening ? 'fa-refresh fa-spin' : 'fa-cog ')}></i>
							</div>
							:
							<OverlayTrigger delayShow={400} overlay={configureTooltip} placement="right">
								<div className="embedSidePanelIcon openScreenSettings" onClick={this.config}>
									<i className={"fa fa-fw " + (this.state.configOpening ? 'fa-refresh fa-spin' : 'fa-cog ')}></i>
								</div>
							</OverlayTrigger>
                        ) : null)
                }

                <div className="embedSidePanelIcon embedSidePanelLogo">
					<OverlayTrigger delayShow={400} overlay={dativeryTooltip} placement="right">
						<a href={config.PUBLIC_WEB_URL} style={{display: 'block'}} target="_new"><MiniLogo color width="35px" /></a>
					</OverlayTrigger>
				</div>
            </div>
        </div>);
    }

	isRealoading() {
		let reloading = lastPanelController() && lastPanelController().state.isReloading || this.props.isReloading;

		if (reloading && lastPanelController() && !lastPanelController().fullscreen) {
			let panelState = lastPanelController().state;
			lastPanelController().resizeDefaultHeight(!panelState.initialized || panelState.haveScreenData);
		}

		return reloading;
	}

    render() {
        let classes = " " + this.getClassName();

        let sidePanelClass;
        let contentClass;

        /* don't show injection style in fullscreen */
        let isInjected = lastPanelController() && lastPanelController().state.isInjected && !this.isFullScreen();
        let isHorizontal = !lastPanelController() || lastPanelController().state.orientation === "horizontal";

        if (isHorizontal) {
			/* Note: attempt for unified design and feeling between injceted and overlayed panel */
            // if (isInjected) {
            //     sidePanelClass = "embedRightPanel";
            //     contentClass = "embedContentRight";
            // } else {
                sidePanelClass = "embedLeftPanel";
                contentClass = "embedContentLeft";
            // }
        } else {
            sidePanelClass = "embedTopPanel";
            contentClass = "embedContentTop";
        }

		if (isScreenSettingsOnlyIframe()) {
			classes += " screenSettingsOnlyIframe ";
		}

        if (isInjected) {
            classes += " embedDativeryPanelInjected ";
        } else {
            classes += " embedDativeryPanelNotInjected ";
        }

        if (this.props.className) {
            contentClass += " " + this.props.className;
        }

		if (lastPanelController() && lastPanelController().state.isReloading || this.props.isReloading && !this.isMini()) {
			LoadingLine.start();
		}
		else {
			LoadingLine.stop();
		}

        return (
            <div className={classes} data-dativery-type={this.props.typeForTest} id="embedDativeryPanel">
                <div className={isInjected === false ? "embedDativeryPanel embedDativeryPanelWithShadow" : "embedDativeryPanel"}>
                    {/* ISSUE #319 ** isInjected === false ? <div className="embedDativeryResizeLine" id="embedDativeryResizeLine"></div> : null*/}
                    <div className={"embedSidePanel " + sidePanelClass}>
                        {this.renderSidePanel(isInjected, isHorizontal)}
                    </div>
					<div className={"embedContent " + contentClass} ref="embedContentClient">
						{isScreenSettingsOnlyIframe() && !LoadingLine.exists() ? (this.props.isReloading ? <LoadingLine /> : <LoadingLine stopped />) : null}
						{this.props.children}
					</div>
                </div>
            </div>
        );
    }
}

class FullScreenPanel_ extends BasicPanel {
    getClassName() {
        return "embedDativeryPanelFullscreen";
    }

    isFullScreen() {
        return true;
    }

    constructor(props) {
        super(props);
    }

    render() {
        if (lastPanelController()) {
            lastPanelController().needFullScreenPanel();
        }

		return super.render();
    }
}
export let FullScreenPanel = injectIntl(FullScreenPanel_);


class RegularPanel_ extends BasicPanel {
    getClassName() {
        return "embedDativeryPanelNormal";
    }

    constructor(props) {
        super(props);
    }

    render() {
        if (lastPanelController()) {
            lastPanelController().needRegularPanel();
        }

        return super.render();
    }
}
export let RegularPanel = injectIntl(RegularPanel_);

class MiniPanel_ extends BasicPanel {
	static propTypes = {
		className: PropTypes.string,
		visibleTooltip: PropTypes.bool,
	};

    getClassName() {
		let className = isPanelInjected() ? 'embedDativeryPanelNormal' : 'embedDativeryPanelSmall';

		if (this.props.className) {
			className += ' ' + this.props.className;
		}

		return className;
    }

    isMini() {
        return true;
    }

    constructor(props) {
        super(props);
    }

    render() {
        if (lastPanelController()) {
			let lastPanel = lastPanelController();
			let lastPanelState = lastPanel.state;
			// TODO: screenInfo is not defined
			if (lastPanelState && lastPanelState.screenInfo && lastPanelState.screenInfo.listWithoutPanel) {
				lastPanel.tooltip = true;
			}
            lastPanel.needMiniPanel(lastPanelState.haveScreenData, this.props.visibleTooltip);
        }

        return super.render();
    }
}
export let MiniPanel = injectIntl(MiniPanel_);

class UnknownPanel_ extends BasicPanel {
    constructor(props) {
        super(props);
    }

	isMini() {
		return isPanelInjected();
	}

    getClassName() {
        if (this.isMini()) {
            return "embedDativeryPanelNormal";
        } else {
            return "embedDativeryPanelSmall";
        }
    }
}

export let UnknownPanel = injectIntl(UnknownPanel_);
